import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';
import {
  TranslatePipe,
  TranslateService,
  TranslateModule,
} from '@ngx-translate/core';
import {
  CustomerListModel,
  CustomerModel,
  LocationModel,
  WarehouseListModel,
  WarehouseModel,
} from '@kanzi-apes/kanzi-models';
import { LayoutService } from '../../services/layout/layout.service';
import { CommonModule } from '@angular/common';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { KanziUIWarehouseRootSelectorComponent } from '../kanzi-ui-warehouse-root-selector/kanzi-ui-warehouse-root-selector.component';
import { CustomerSelectorComponent } from '../customer-selector/customer-selector.component';
@Component({
    selector: 'kanzi-ui-top-bar',
    imports: [
        CommonModule,
        TranslatePipe,
        KanziPrimeUiModule,
        KanziUIWarehouseRootSelectorComponent,
        TranslateModule,
        CustomerSelectorComponent,
    ],
    templateUrl: './kanzi-ui-top-bar.component.html',
    styleUrls: ['./kanzi-ui-top-bar.component.scss']
})
export class KanziUiTopBarComponent {
  @ViewChild('menuButton') menuButton!: ElementRef;
  @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;
  wereHouseListHide = input(false, { transform: booleanAttribute });
  dataloaderHide = input<boolean>(false);
  warehouseRootList = input<WarehouseListModel | null>();
  warehouseRFIDList = input<LocationModel[] | null>();
  warehouseRootSelected = input<WarehouseModel | null>();
  warehouseRFIDRootsSelected = input<LocationModel | null>();
  warehouseRFIDMode = input<boolean>(false);
  customers = input<CustomerListModel | null>();
  customerSelected = input<CustomerModel | null>();
  isParent = input<boolean>(false);
  @Output() selectWarehouseRoot: EventEmitter<WarehouseModel> =
    new EventEmitter();
  @Output() selectWarehouseRFIDRoot: EventEmitter<LocationModel> =
    new EventEmitter();
  @Output() selectLanguage: EventEmitter<string> = new EventEmitter();
  @Output() changeCustomer = new EventEmitter();

  layoutService: LayoutService = inject(LayoutService);
  activeItem!: number;
  languajes = [
    { value: 'en', label: 'Inglés', code: 'us' },
    { value: 'es', label: 'Español', code: 'es' },
    { value: 'pr', label: 'Portugués', code: 'br' },
  ];

  /**
   * Constructor
   * @param el {ElementRef} - ElementRef
   */
  constructor(
    public el: ElementRef,
    public translateService: TranslateService
  ) {}

  /**
   * Get mobile topbar active
   * return {boolean}
   */
  get mobileTopbarActive(): boolean {
    return this.layoutService.state.topbarMenuActive;
  }

  /**
   * Get menu toggle action
   */
  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  /**
   * Get mobile topbar menu button click
   */
  onMobileTopbarMenuButtonClick() {
    this.layoutService.onTopbarMenuToggle();
  }

  onSelectWarehouse(warehouseRoot: WarehouseModel) {
    this.selectWarehouseRoot.emit(warehouseRoot);
  }

  onSelectWarehouseRFID(warehouseRoot: LocationModel) {
    this.selectWarehouseRFIDRoot.emit(warehouseRoot);
  }

  get logo() {
    const logo =
      this.layoutService._config.menuTheme === 'light' ||
      this.layoutService._config.menuTheme === 'dark'
        ? 'dark'
        : 'white';
    return logo;
  }

  /**
   * Change languaje
   * @param lang {string} - Language
   */
  changeLanguaje(lang: string) {
    this.selectLanguage.emit(lang);
  }

  /**
   * Select customer
   * @param customer {CustomerModel} - Customer
   */
  selectCustomer(customer: CustomerModel) {
    this.changeCustomer.emit(customer);
  }
}
